import { Api } from 'utils';

class ConsultationPlanService {
	
	static admin = {
		get: async (params?: any) => Api.createResponse('admin/consultation-plans',params),
		save: async (params?: any) => Api.createResponse('admin/consultation-plans/save',params),
		saveUser: async (params?: any) => Api.createResponse('admin/consultation-plans/save-user',params),
		delete: async (params?: any) => Api.createResponse('admin/consultation-plans/delete',params),
		getPlanList: async (params?: any) => Api.createResponse('admin/consultation-plans/plan-list',params),
		deletePlanUser: async (params?: any) => Api.createResponse('admin/consultation-plans/delete-plan-user',params),
	}

}

export default ConsultationPlanService;